<template>
    <div v-if="$root.isMobile" class="mobile-page-title">
        <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-primary btn-sm" @click="showFilters = true" style="width: 80px;">
                <i class="fal fa-sliders-h"></i> Filtri
            </button>
            <h4 class="mb-0 font-weight-bold flex-grow-1 text-center">
                Pagamenti
            </h4>
            <button type="button" class="btn btn-success btn-sm d-flex justify-content-center align-items-center" @click="nuovoPagamento()" style="width: 40px; height: 31px;">
                <i class="fas fa-plus ml-2"></i>
            </button>
        </div>
    </div>
    <div class="kt-portlet__head">

        <div v-if="$root.isMobile">


            <div class="offcanvas-backdrop" :class="{ show: showFilters }" @click.self="showFilters = false">

                <aside class="offcanvas-panel" :class="{ open: showFilters }" role="dialog" aria-modal="true">
                    <div class="offcanvas-header" style="background: linear-gradient(135deg, #004B80, #00802B);">
                        <h6 class="mb-0 text-light"><i class="fal fa-filter"></i> Filtri ricerca</h6>
                        <button type="button" class="btn btn-light btn-sm" @click="showFilters = false">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <div class="offcanvas-body">
                        <form class="isprint-filter" autocomplete="off" @submit.prevent>
                            <div class="mb-3">
                                <label class="mb-1">Id Pagamento</label>
                                <input class="form-control form-control-sm" placeholder="Codice Agente"
                                    v-model="search.ID_PAGAMENTO.VALUE">
                            </div>

                            <div class="mb-3">
                                <label class="mb-1">Data Pagamento Da</label>
                                <input class="form-control form-control-sm" placeholder="Area di Competenza"
                                    v-model="search.DATA_PAGAMENTO.VALUE_FROM">
                            </div>
                            <div class="mb-3">
                                <label class="mb-1">Data Pagamento A</label>
                                <input class="form-control form-control-sm" placeholder="Area di Competenza"
                                    v-model="search.DATA_PAGAMENTO.VALUE_TO">
                            </div>

                            <div class="mb-3">
                                <label class="mb-1">Importo</label>
                                <input class="form-control form-control-sm" placeholder="Descrizione Pagamento"
                                    v-model="search.DESCRIZIONE.VALUE">
                            </div>
                            <div class="mb-3">
                                <label class="mb-1">Importo</label>
                                <input class="form-control form-control-sm" placeholder="Descrizione Agente"
                                    v-model="search.DESCRIZIONE_AGENTE.VALUE">
                            </div>
                             <div class="mb-3">
                                <label>Stato</label><br />
                                <select class="form-control form-control-sm" v-model="search.STATO.VALUE" style="width:150px">
                                    <option value="" selected>Tutti</option>
                                    <option value="0">Non Saldato</option>
                                    <option value="1">Saldato</option>
                                </select>
                            </div>
                        </form>
                    </div>
                </aside>
            </div>
        </div>


        <form v-else class="isprint-filter" autocomplete="off" :style="{ marginBottom: $root.isTablet ? '150px' : '' }">
            <div class="form-group">
                <label>Id Pagamento</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Id Pagamento"
                    type="text" style="width:150px" v-model="search.ID_PAGAMENTO.VALUE">
            </div>
            <div class="form-group">
                <label>Agente</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Agente"
                    type="text" style="width:150px" v-model="search.DESCRIZIONE_AGENTE.VALUE">
            </div>
            <div class="form-group">
                <label>Importo</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Importo"
                    type="text" style="width:150px" v-model="search.IMPORTO.VALUE">
            </div>
            <div class="form-group"> <label>Data Pagamento Da</label><br />
                <DatePicker placeholder="Data inizio" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_PAGAMENTO.VALUE_FROM">
                </DatePicker>
            </div>
            <div class="form-group"> <label>Data Pagamento A</label><br />
                <DatePicker placeholder="Data fine" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                    v-model="search.DATA_PAGAMENTO.VALUE_TO">
                </DatePicker>
            </div>
            <div class="form-group">
                <label>Descrizione</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Descrizione"
                    type="text" style="width:150px" v-model="search.DESCRIZIONE.VALUE">
            </div>
            <div class="form-group">
                <label>Stato</label><br />
                <select class="form-control form-control-sm" v-model="search.STATO.VALUE" style="width:150px">
                    <option value="" selected>Tutti</option>
                    <option value="0">Non elaborato</option>
                    <option value="1">Elaborato</option>
                </select>
            </div>
            <div class="form-group float-right">
                <button class="btn btn-success float-right btn-sm " v-on:click="nuovoPagamento()"
                    style="margin-top:26px"><i class="fal fa-plus"></i> Nuovo Pagamento</button>
            </div>
        </form>
    </div>
    <div class="isprint-grid-container">
        <div v-if="$root.isMobile" class="row justify-content-center">
            <div class="col-12 mb-4" v-for="pagamento in paginatedList.arr" :key="pagamento.ID_PAGAMENTO">
                <div class="card shadow border-0 text-center p-3" style="border-radius: 20px;">
                    <div class="card-body">
                        <i class="fad fa-euro-sign fa-6x  mb-3" aria-hidden="true"></i>

                        <h5 class="card-title">Pagamento a {{ pagamento.DESCRIZIONE_AGENTE }}</h5>

                        <p class="mb-1"><strong>Importo:</strong> {{ pagamento.IMPORTO }} €</p>
                        <p class="mb-1"><strong>Data Pagamento:</strong> {{ filters.formatDateTime(pagamento.DATA_PAGAMENTO) || '—' }}</p>
                        <p class="mb-1"><strong>Descrizione:</strong> {{ pagamento.DESCRIZIONE }}</p>


                        <div
                            :class="['d-flex', 'mt-3', pagamento.STATO == 1 ? 'justify-content-center' : 'justify-content-between']">

                            <ISwitch v-model="pagamento.STATO" @toggle="updateStato(pagamento)" :size="'sm'"
                                style="margin-top:6px"></ISwitch>

                            <button v-if="pagamento.STATO == 0" class="btn btn-danger btn-sm"
                                @click="eliminaPagamento(pagamento)" title="Elimina Pagamento">
                                <i class="fal fa-trash-alt"></i>
                            </button>

                        </div>


                    </div>
                </div>
            </div>
        </div>

        <table v-else class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="left: 0px; background: linear-gradient(135deg, #004B80, #00802B); color:#fff;">
                    <th style="width:10%"><span>Id Pagamento</span></th>
                    <th style="width:20%"><span>Agente</span></th>
                    <th style="width:10%"><span>Importo</span></th>
                    <th style="width:20%"><span>Data Pagamento</span></th>
                    <th style="width:20%"><span>Descrizione</span></th>
                    <th style="width:10%"><span>Stato</span></th>
                    <th style="width:10%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-for="pagamento in paginatedList.arr"
                    v-bind:key="pagamento.ID_PAGAMENTO">
                    <td style="width:10%">
                        <kbd style="font-size:16px">{{ pagamento.ID_PAGAMENTO }}</kbd>
                    </td>
                    <td style="width:20%">
                        <span>
                            <i class="fad fa-user-secret fa-2x mr-2" aria-hidden="true"></i>
                            <strong>{{ pagamento.DESCRIZIONE_AGENTE != null ? pagamento.DESCRIZIONE_AGENTE : 'Nessun Agente Associato'}}</strong>
                        </span>
                    </td>
                    <td style="width:10%">
                        <strong>{{ pagamento.IMPORTO }}</strong> <i class="fad fa-euro-sign"></i>
                    </td>
                    <td style="width:20%">
                        <i class="fad fa-calendar-day fa-2x mr-2"></i>
                        {{ filters.formatDateTime(pagamento.DATA_PAGAMENTO) }}
                    </td>
                    <td style="width:20%; cursor: pointer;"
                        @click="mostraDescrizioneCompleta(pagamento.DESCRIZIONE)"
                        :title="pagamento.DESCRIZIONE">
                        {{ filters.accorciaTesto(pagamento.DESCRIZIONE,30) }}
                        <i v-if="pagamento.DESCRIZIONE && pagamento.DESCRIZIONE.length > 30" class="fas fa-expand-alt text-muted ml-1" style="font-size: 10px;"></i>
                    </td>
                    <td style="width:10%; display: flex; align-items: center; justify-content: space-between;">

                        <span style="margin-top: 12px;" class="badge badge-success"
                            v-if="pagamento.STATO == 1">Saldato</span>
                        <span style="margin-top: 12px;" class="badge badge-danger" v-else-if="pagamento.STATO == 0">Da
                            Saldare</span>
                        <span style="margin-left: 12px;">
                            <ISwitch style="margin-top: 12px;" v-model="pagamento.STATO"
                                @toggle="updateStato(pagamento)" :size="'sm'"></ISwitch>
                        </span>

                    </td>

                    <td style="width:10%; ">
                        <div v-if="pagamento.STATO != 1" class="float-right">
                            <button data-toggle="tooltip" data-placement="top" title="Elimina pagamento"
                                class="btn btn-danger btn-sm" v-on:click="deletePagamento(pagamento)"><i
                                    class="fal fa-trash-alt"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>

    <!-- MODALE  -->
    <div class="modal fade" id="popUpPagamento" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog" :class="currentStep === 1 ? 'modal-md' : 'modal-xl'">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background: linear-gradient(135deg, #004B80, #00802B);">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-euro-sign fa-fw"></i> Pagamento</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- STEP 1: Selezione Agente -->
                    <div v-if="currentStep === 1">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label><h5>Seleziona l'Agente per cui effettuare il pagamento:</h5></label>
                                    <Select2 v-model="pagamentoSelezionato.FK_ID_AGENTE" :w="$root.isMobile ? 150 : 800"
                                        :api="'dcp/agente/select2?a=1'" :apiselected="'dcp/agente/s2'"></Select2>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 text-right">
                                <button class="btn btn-primary btn-lg" @click="goToStep2()" :disabled="!pagamentoSelezionato.FK_ID_AGENTE">
                                    Avanti <i class="fas fa-arrow-right ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- STEP 2: Selezione tipo contratto -->
                    <div v-if="currentStep === 2">
                        <div class="row mb-3">
                            <div class="col-12">
                                <button class="btn btn-secondary btn-sm" @click="currentStep = 1">
                                    <i class="fas fa-arrow-left"></i> Indietro
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <div class="card h-100 shadow-sm" style="cursor: pointer; border: 2px solid transparent;"
                                     :class="{ 'border-warning': tipoSelezionato === 'POD' }"
                                     @click="selezionaTipo('POD')">
                                    <div class="card-body text-center">
                                        <i class="fas fa-lightbulb fa-5x text-warning mb-3"></i>
                                        <h5 class="card-title">POD - Energia Elettrica</h5>
                                        <p class="text-muted">Ciclo 13 mesi - Pagamento ricorrente</p>
                                        <h3 class="text-warning">{{ podDaLiquidare.count }}</h3>
                                        <p class="mb-0">contratti da liquidare</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <div class="card h-100 shadow-sm" style="cursor: pointer; border: 2px solid transparent;"
                                     :class="{ 'border-danger': tipoSelezionato === 'PDR' }"
                                     @click="selezionaTipo('PDR')">
                                    <div class="card-body text-center">
                                        <i class="fas fa-gas-pump fa-5x text-danger mb-3"></i>
                                        <h5 class="card-title">PDR - Gas</h5>
                                        <p class="text-muted">Pagamento una tantum</p>
                                        <h3 class="text-danger">{{ fatturePdrDaLiquidare.length }}</h3>
                                        <p class="mb-0">fatture da liquidare</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 justify-content-center">
                            <div class="col-md-6 mb-3">
                                <div class="card h-100 shadow-sm" style="cursor: pointer; border: 2px solid transparent;"
                                     :class="{ 'border-secondary': tipoSelezionato === 'GENERICO' }"
                                     @click="selezionaTipo('GENERICO')">
                                    <div class="card-body text-center">
                                        <i class="fas fa-hand-holding-usd fa-5x text-secondary mb-3"></i>
                                        <h5 class="card-title">Pagamento Generico</h5>
                                        <p class="text-muted">Pagamento libero all'agente senza POD o PDR</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- STEP 3: Lista contratti del tipo selezionato -->
                    <div v-if="currentStep === 3">
                        <div class="row mb-3">
                            <div class="col-6">
                                <button class="btn btn-secondary btn-sm" @click="currentStep = 2">
                                    <i class="fas fa-arrow-left"></i> Indietro
                                </button>
                            </div>
                            <!-- Pulsante Avanti in alto per mobile -->
                            <div class="col-6 text-right" v-if="$root.isMobile && ((tipoSelezionato === 'POD' && contrattiSelezionati.length > 0) || (tipoSelezionato === 'PDR' && fattureSelezionate.length > 0))">
                                <button class="btn btn-primary btn-sm" @click="goToStep4()">
                                    Avanti <i class="fas fa-arrow-right ml-1"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Riepilogo selezione in alto per mobile -->
                        <div v-if="$root.isMobile && ((tipoSelezionato === 'POD' && contrattiSelezionati.length > 0) || (tipoSelezionato === 'PDR' && fattureSelezionate.length > 0))"
                             class="alert alert-success py-2 mb-3" style="font-size: 0.85rem;">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>
                                    <i class="fas fa-check-circle"></i>
                                    <span v-if="tipoSelezionato === 'POD'">{{ contrattiSelezionati.length }} POD</span>
                                    <span v-if="tipoSelezionato === 'PDR'">{{ fattureSelezionate.length }} fatture</span>
                                </span>
                                <strong>{{ calcolaTotaleGettoni() }}€</strong>
                            </div>
                        </div>

                        <!-- Tabella POD -->
                        <div v-if="tipoSelezionato === 'POD'">
                            <h6 class="mb-3">
                                <i class="fas fa-lightbulb text-warning"></i>
                                POD da liquidare ({{ podDaLiquidare.count }})
                            </h6>
                            <small class="text-muted d-block mb-3">Ciclo 13 mesi - Pagamento ricorrente</small>
                             <form class="isprint-filter" autocomplete="off">
                                <div class="form-group">
                                    <label>POD</label><br />
                                    <input class="form-control form-control-sm" placeholder="Filtra per POD..." v-model="searchPod.POD.VALUE">
                                </div>
                             </form>


                            <div v-if="podDaLiquidare.count > 0">
                                <!-- Desktop: Tabella -->
                                <table v-if="!$root.isMobile" class="isprint-grid shadow table-contratti-modal">
                                    <thead class="isprint-grid-thead">
                                        <tr style="left: 0px; background: linear-gradient(135deg, #004B80, #00802B); color:#fff;">
                                            <th style="width:5%">
                                                <input type="checkbox"
                                                       @change="toggleAllPod($event)"
                                                       style="width: 20px; height: 20px; cursor: pointer;">
                                            </th>
                                            <th style="width:18%"><span>POD</span></th>
                                            <th style="width:27%"><span>Denominazione</span></th>
                                            <th style="width:12%"><span>Gettone</span></th>
                                            <th style="width:15%"><span>Tipo Pagamento</span></th>
                                            <th style="width:13%"><span>Ultima Liquidazione</span></th>
                                            <th style="width:5%"><span>Info</span></th>
                                        </tr>
                                    </thead>
                                    <tbody class="isprint-grid-tbody tbody-scrollable">
                                        <tr v-for="contratto in podDaLiquidare.arr"
                                            :key="contratto.ID_CONTRATTO"
                                            style="left: 0px; height:50px; cursor: pointer;"
                                            @click="toggleContratto(contratto.ID_CONTRATTO)"
                                            :class="{ 'table-active': contrattiSelezionati.includes(contratto.ID_CONTRATTO) }">
                                            <td style="width:5%; text-align: center;">
                                                <input type="checkbox"
                                                       :value="contratto.ID_CONTRATTO"
                                                       v-model="contrattiSelezionati"
                                                       @click.stop
                                                       style="width: 20px; height: 20px; cursor: pointer;">
                                            </td>
                                            <td style="width:18%">
                                                <strong>{{ contratto.POD }}</strong>
                                            </td>
                                            <td style="width:27%">
                                                <span>{{ contratto.DENOMINAZIONE }}</span>
                                            </td>
                                            <td style="width:12%">
                                                <strong class="text-success">{{ filters.formatCash(contratto.GETTONE_MATURATO || contratto.GETTONE_CONTRATTO) }}€</strong>
                                            </td>
                                            <td style="width:15%">
                                                <span v-if="contratto.FLG_PRIMO_ANNO_PAGATO == 1" class="badge bg-warning text-dark">
                                                    <i class="fas fa-forward"></i> Già pagato 1° anno
                                                </span>
                                                <span v-else-if="contratto.MODALITA_PAGAMENTO == 1 && contratto.MESI_TRASCORSI >= 12" class="badge bg-info text-white">
                                                    <i class="fas fa-calendar-day"></i> {{ filters.formatMesiContratto(contratto.MESI_TRASCORSI) }}
                                                </span>
                                                <span v-else class="badge bg-primary text-white">
                                                    <i class="fas fa-calendar-alt"></i> Primo anno
                                                </span>
                                            </td>
                                            <td style="width:13%">
                                                <span v-if="contratto.DATA_ULTIMA_LIQUIDAZIONE" class="badge bg-warning text-dark">
                                                    {{ filters.formatDate(contratto.DATA_ULTIMA_LIQUIDAZIONE) }}
                                                </span>
                                                <span v-else class="badge bg-danger">Mai pagato</span>
                                            </td>
                                            <td style="width:5%; text-align: center;">
                                                <button class="btn btn-info btn-sm" @click.stop="mostraInfoContratto(contratto)" title="Dettagli contratto">
                                                    <i class="fas fa-info-circle"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- Mobile: Card compatte -->
                                <div v-if="$root.isMobile" class="row">
                                    <div class="col-12 mb-2" v-for="contratto in podDaLiquidare.arr" :key="contratto.ID_CONTRATTO">
                                        <div class="card shadow-sm"
                                             :class="{ 'border-success border-2': contrattiSelezionati.includes(contratto.ID_CONTRATTO) }"
                                             @click="toggleContratto(contratto.ID_CONTRATTO)"
                                             style="cursor: pointer;">
                                            <div class="card-body p-2">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex align-items-center">
                                                        <input type="checkbox"
                                                               :value="contratto.ID_CONTRATTO"
                                                               v-model="contrattiSelezionati"
                                                               @click.stop
                                                               style="width: 18px; height: 18px; margin-right: 8px;">
                                                        <div>
                                                            <div style="font-size: 0.8rem; font-weight: bold;">{{ contratto.POD }}</div>
                                                            <div style="font-size: 0.7rem; color: #6c757d;">{{ contratto.DENOMINAZIONE?.substring(0, 25) }}{{ contratto.DENOMINAZIONE?.length > 25 ? '...' : '' }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="text-right">
                                                        <span class="badge badge-success" style="font-size: 0.8rem;">{{ filters.formatCash(contratto.GETTONE_MATURATO || contratto.GETTONE_CONTRATTO) }}€</span>
                                                        <div style="font-size: 0.65rem; color: #6c757d;">
                                                            <span v-if="contratto.DATA_ULTIMA_LIQUIDAZIONE">{{ filters.formatDate(contratto.DATA_ULTIMA_LIQUIDAZIONE) }}</span>
                                                            <span v-else class="text-danger">Mai pagato</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <Pagine v-model="searchPod.PAGINATION.PAGE_NUMBER"
                                        :numrighe="podDaLiquidare.count"
                                        :numpagine="searchPod.PAGINATION.LENGTH">
                                </Pagine>
                            </div>
                            <div v-else class="alert alert-info">
                                <i class="fas fa-info-circle"></i> Nessun POD da liquidare per questo agente
                            </div>
                        </div>

                        <!-- Tabella Fatture PDR -->
                        <div v-if="tipoSelezionato === 'PDR'">
                            <h6 class="mb-3">
                                <i class="fas fa-gas-pump text-danger"></i>
                                Fatture PDR da liquidare ({{ fatturePdrDaLiquidarePaginato.count }})
                            </h6>
                            <small class="text-muted d-block mb-3">Seleziona le fatture pagate dal cliente da liquidare all'agente</small>

                            <form class="isprint-filter" autocomplete="off">
                                <div class="form-group">
                                    <label>Numero Fattura</label><br />
                                     <input class="form-control form-control-sm" placeholder="Filtra per N.Fattura..."
                                    v-model="searchFatturePdr.NUMERO_FATTURA.VALUE">
                                </div>
                                <div class="form-group">
                                    <label>PDR</label><br />
                                    <input class="form-control form-control-sm" placeholder="Filtra per PDR..."
                                    v-model="searchFatturePdr.PDR.VALUE">
                                </div>
                             </form>
                           

                            <div v-if="fatturePdrDaLiquidarePaginato.count > 0">
                                <!-- Desktop: Tabella -->
                                <table v-if="!$root.isMobile" class="isprint-grid shadow table-contratti-modal">
                                    <thead class="isprint-grid-thead">
                                        <tr style="left: 0px; background: linear-gradient(135deg, #004B80, #00802B); color:#fff;">
                                            <th style="width:5%">
                                                <input type="checkbox"
                                                       @change="toggleAllFatturePdr($event)"
                                                       style="width: 20px; height: 20px; cursor: pointer;">
                                            </th>
                                            <th style="width:15%"><span>N. Fattura</span></th>
                                            <th style="width:20%"><span>PDR</span></th>
                                            <th style="width:35%"><span>Cliente</span></th>
                                            <th style="width:15%"><span>MC x Fattore</span></th>
                                        </tr>
                                    </thead>
                                    <tbody class="isprint-grid-tbody tbody-scrollable">
                                        <tr v-for="fattura in fatturePdrDaLiquidarePaginato.arr"
                                            :key="fattura.ID_FATTURA"
                                            style="left: 0px; height:50px; cursor: pointer;"
                                            @click="toggleFattura(fattura.ID_FATTURA)"
                                            :class="{ 'table-active': fattureSelezionate.includes(fattura.ID_FATTURA) }">
                                            <td style="width:5%; text-align: center;">
                                                <input type="checkbox"
                                                       :value="fattura.ID_FATTURA"
                                                       v-model="fattureSelezionate"
                                                       @click.stop
                                                       style="width: 20px; height: 20px; cursor: pointer;">
                                            </td>
                                            <td style="width:15%">
                                                <strong>{{ fattura.NUMERO_FATTURA }}</strong>
                                            </td>
                                            <td style="width:20%">
                                                <span>{{ fattura.PDR }}</span>
                                            </td>
                                            <td style="width:35%">
                                                <span>{{ fattura.DENOMINAZIONE }}</span>
                                            </td>
                                            <td style="width:15%">
                                                <strong class="text-success">{{ (fattura.MC_FATTURATI * fattura.FATTORE_FAT).toFixed(2) }}€</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- Mobile: Card compatte -->
                                <div v-if="$root.isMobile" class="row">
                                    <div class="col-12 mb-2" v-for="fattura in fatturePdrDaLiquidarePaginato.arr" :key="fattura.ID_FATTURA">
                                        <div class="card shadow-sm"
                                             :class="{ 'border-success border-2': fattureSelezionate.includes(fattura.ID_FATTURA) }"
                                             @click="toggleFattura(fattura.ID_FATTURA)"
                                             style="cursor: pointer;">
                                            <div class="card-body p-2">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex align-items-center">
                                                        <input type="checkbox"
                                                               :value="fattura.ID_FATTURA"
                                                               v-model="fattureSelezionate"
                                                               @click.stop
                                                               style="width: 18px; height: 18px; margin-right: 8px;">
                                                        <div>
                                                            <div style="font-size: 0.8rem; font-weight: bold;">{{ fattura.NUMERO_FATTURA }}</div>
                                                            <div style="font-size: 0.7rem; color: #6c757d;">{{ fattura.PDR }}</div>
                                                            <div style="font-size: 0.65rem; color: #999;">{{ fattura.DENOMINAZIONE?.substring(0, 20) }}{{ fattura.DENOMINAZIONE?.length > 20 ? '...' : '' }}</div>
                                                        </div>
                                                    </div>
                                                    <span class="badge badge-success" style="font-size: 0.8rem;">{{ (fattura.MC_FATTURATI * fattura.FATTORE_FAT).toFixed(2) }}€</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <Pagine v-model="searchFatturePdr.PAGINATION.PAGE_NUMBER"
                                        :numrighe="fatturePdrDaLiquidarePaginato.count"
                                        :numpagine="searchFatturePdr.PAGINATION.LENGTH">
                                </Pagine>
                            </div>
                            <div v-else class="alert alert-info">
                                <i class="fas fa-info-circle"></i> Nessuna fattura PDR da liquidare per questo agente
                            </div>
                        </div>

                        <!-- Riepilogo selezione (solo desktop) -->
                        <div v-if="!$root.isMobile && ((tipoSelezionato === 'POD' && contrattiSelezionati.length > 0) || (tipoSelezionato === 'PDR' && fattureSelezionate.length > 0))" class="alert alert-success mt-3">
                            <h5 class="mb-3">
                                <i class="fas fa-check-circle"></i>
                                Totale da liquidare: {{ calcolaTotaleGettoni() }}€
                            </h5>
                            <p class="mb-0" v-if="tipoSelezionato === 'POD'">{{ contrattiSelezionati.length }} contratti selezionati</p>
                            <p class="mb-0" v-if="tipoSelezionato === 'PDR'">{{ fattureSelezionate.length }} fatture selezionate</p>
                        </div>

                        <!-- Bottone Avanti verso Step 4 (solo desktop) -->
                        <div v-if="!$root.isMobile && ((tipoSelezionato === 'POD' && contrattiSelezionati.length > 0) || (tipoSelezionato === 'PDR' && fattureSelezionate.length > 0))" class="row mt-4">
                            <div class="col-12 text-right">
                                <button class="btn btn-primary btn-lg" @click="goToStep4()">
                                    Avanti <i class="fas fa-arrow-right ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- STEP 4: Dettagli Pagamento -->
                    <div v-if="currentStep === 4">
                        <div class="row mb-3">
                            <div class="col-12">
                                <button class="btn btn-secondary btn-sm" @click="tipoSelezionato === 'GENERICO' ? currentStep = 2 : currentStep = 3">
                                    <i class="fas fa-arrow-left"></i> Indietro
                                </button>
                            </div>
                        </div>

                        <h6 class="mb-4">
                            <i class="fas fa-file-invoice-dollar"></i>
                            Dettagli Pagamento
                        </h6>

                        <!-- Campo importo per pagamento generico -->
                        <div v-if="tipoSelezionato === 'GENERICO'" class="alert alert-secondary mb-4">
                            <div class="row align-items-center">
                                <div class="col-md-6">
                                    <strong><i class="fas fa-hand-holding-usd"></i> Pagamento Generico</strong>
                                    <p class="mb-0 small text-muted mt-1">Inserisci l'importo da pagare all'agente</p>
                                </div>
                                <div class="col-md-6">
                                    <div class="input-group">
                                        <input type="number"
                                               class="form-control form-control-lg text-right"
                                               v-model="pagamentoSelezionato.IMPORTO"
                                               placeholder="0.00"
                                               min="0"
                                               step="0.01">
                                        <div class="input-group-append">
                                            <span class="input-group-text">€</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Riepilogo importo -->
                        <div v-if="tipoSelezionato !== 'GENERICO'" class="alert alert-info mb-4">
                            <div class="row">
                                <div class="col-md-6">
                                    <strong v-if="tipoSelezionato === 'POD'">Contratti selezionati:</strong>
                                    <strong v-if="tipoSelezionato === 'PDR'">Fatture selezionate:</strong>
                                    <span v-if="tipoSelezionato === 'POD'">{{ contrattiSelezionati.length }}</span>
                                    <span v-if="tipoSelezionato === 'PDR'">{{ fattureSelezionate.length }}</span>
                                    <div class="mt-2">
                                        <small v-if="tipoSelezionato === 'POD'">
                                            <i class="fas fa-lightbulb text-warning"></i> POD: {{ contrattiSelezionati.length }}
                                        </small>
                                        <small v-if="tipoSelezionato === 'PDR'">
                                            <i class="fas fa-gas-pump text-danger"></i> Fatture PDR: {{ fattureSelezionate.length }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-6 text-right">
                                    <strong>Totale:</strong> <span class="text-success" style="font-size: 1.2em;">{{ calcolaTotaleGettoni() }}€</span>
                                </div>
                            </div>
                        </div>

                        <!-- Lista contratti/fatture selezionate -->
                        <div v-if="tipoSelezionato !== 'GENERICO'" class="mb-4">
                            <h6 class="mb-3" v-if="tipoSelezionato === 'POD'">Dettaglio Contratti POD</h6>
                            <h6 class="mb-3" v-if="tipoSelezionato === 'PDR'">Dettaglio Fatture PDR</h6>

                            <!-- Desktop: Card con tabella -->
                            <div v-if="!$root.isMobile" class="card">
                                <div class="card-body p-0">
                                    <div class="table-responsive" style="max-height: 250px; overflow-y: auto;">
                                        <!-- Tabella POD -->
                                        <table v-if="tipoSelezionato === 'POD'" class="table table-sm table-striped mb-0">
                                            <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                                <tr>
                                                    <th style="width: 8%">Tipo</th>
                                                    <th style="width: 18%">POD</th>
                                                    <th style="width: 25%">Cliente</th>
                                                    <th style="width: 10%" class="text-right">Gettone</th>
                                                    <th style="width: 15%">Modalità</th>
                                                    <th style="width: 24%">Data Fine Liquidazione</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="contratto in getContrattiSelezionatiDettaglio()" :key="contratto.ID_CONTRATTO">
                                                    <td>
                                                        <span class="badge badge-warning">
                                                            <i class="fas fa-lightbulb"></i> POD
                                                        </span>
                                                    </td>
                                                    <td><strong>{{ contratto.POD }}</strong></td>
                                                    <td><small>{{ contratto.DENOMINAZIONE }}</small></td>
                                                    <td class="text-right"><strong class="text-success">{{ contratto.GETTONE_MATURATO || contratto.GETTONE_CONTRATTO }}€</strong></td>
                                                    <td>
                                                        <span v-if="contratto.FLG_PRIMO_ANNO_PAGATO == 1" class="badge bg-warning text-dark">
                                                            <i class="fas fa-forward"></i> 1° anno pagato
                                                        </span>
                                                        <span v-else-if="contratto.MODALITA_PAGAMENTO == 1 && contratto.MESI_TRASCORSI >= 12" class="badge bg-info text-white">
                                                            <i class="fas fa-calendar-day"></i> {{ filters.formatMesiContratto(contratto.MESI_TRASCORSI) }}
                                                        </span>
                                                        <span v-else class="badge bg-primary text-white">
                                                            <i class="fas fa-calendar-alt"></i> Anno 1
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <!-- POD liquidato: mostra data modificabile -->
                                                        <div v-if="contratto.DATA_PROSSIMA_LIQUIDAZIONE && isContrattoLiquidato(contratto)">
                                                            <DatePicker
                                                                :dim="'sm'"
                                                                v-model="contratto.DATA_PROSSIMA_LIQUIDAZIONE_EDIT"
                                                                placeholder="Data fine liquidazione"
                                                                :style="isDataLiquidazioneValida(contratto) ? 'width: 100%;' : 'width: 100%; border: 2px solid #dc3545; border-radius: 4px;'">
                                                            </DatePicker>
                                                            <small class="text-muted d-block">
                                                                Attuale: {{ filters.formatDate(contratto.DATA_PROSSIMA_LIQUIDAZIONE) }}
                                                            </small>
                                                            <small v-if="!isDataLiquidazioneValida(contratto)" class="text-danger d-block">
                                                                <i class="fas fa-exclamation-triangle"></i> Deve essere almeno 1 mese dopo l'ultima liquidazione
                                                            </small>
                                                        </div>
                                                        <!-- POD non liquidato -->
                                                        <span v-else class="badge badge-info">
                                                            <i class="fas fa-info-circle"></i> Primo pagamento
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <!-- Tabella Fatture PDR -->
                                        <table v-if="tipoSelezionato === 'PDR'" class="table table-sm table-striped mb-0">
                                            <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                                <tr>
                                                    <th style="width: 10%">Tipo</th>
                                                    <th style="width: 20%">N. Fattura</th>
                                                    <th style="width: 22%">PDR</th>
                                                    <th style="width: 30%">Cliente</th>
                                                    <th style="width: 18%" class="text-right">MC x Fattore</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="fattura in getFattureSelezionateDettaglio()" :key="fattura.ID_FATTURA">
                                                    <td>
                                                        <span class="badge badge-danger">
                                                            <i class="fas fa-gas-pump"></i> PDR
                                                        </span>
                                                    </td>
                                                    <td><strong>{{ fattura.NUMERO_FATTURA }}</strong></td>
                                                    <td>{{ fattura.PDR }}</td>
                                                    <td><small>{{ fattura.DENOMINAZIONE }}</small></td>
                                                    <td class="text-right"><strong class="text-success">{{ (fattura.MC_FATTURATI * fattura.FATTORE_FAT).toFixed(2) }}€</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <!-- Mobile: Lista card -->
                            <div v-if="$root.isMobile">
                                <!-- Card POD -->
                                <div v-if="tipoSelezionato === 'POD'" class="row">
                                    <div class="col-12 mb-3" v-for="contratto in getContrattiSelezionatiDettaglio()" :key="contratto.ID_CONTRATTO">
                                        <div class="card shadow-sm border-warning">
                                            <div class="card-body p-3">
                                                <div class="d-flex justify-content-between align-items-start mb-2">
                                                    <span class="badge badge-warning">
                                                        <i class="fas fa-lightbulb"></i> POD
                                                    </span>
                                                    <span class="badge badge-success font-weight-bold">
                                                        {{ contratto.GETTONE_MATURATO || contratto.GETTONE_CONTRATTO }}€
                                                    </span>
                                                </div>
                                                <h6 class="mb-1"><strong>{{ contratto.POD }}</strong></h6>
                                                <p class="text-muted mb-2 small">{{ contratto.DENOMINAZIONE }}</p>
                                                <div class="mb-2">
                                                    <span v-if="contratto.FLG_PRIMO_ANNO_PAGATO == 1" class="badge bg-warning text-dark">
                                                        <i class="fas fa-forward"></i> 1° anno già pagato
                                                    </span>
                                                    <span v-else-if="contratto.MODALITA_PAGAMENTO == 1 && contratto.MESI_TRASCORSI >= 12" class="badge bg-info text-white">
                                                        <i class="fas fa-calendar-day"></i> {{ filters.formatMesiContratto(contratto.MESI_TRASCORSI) }} - Mensile
                                                    </span>
                                                    <span v-else class="badge bg-primary text-white">
                                                        <i class="fas fa-calendar-alt"></i> Anno 1 - Annuale
                                                    </span>
                                                </div>
                                                <div v-if="contratto.DATA_PROSSIMA_LIQUIDAZIONE && isContrattoLiquidato(contratto)">
                                                    <label class="small text-muted mb-1">Data fine liquidazione:</label>
                                                    <DatePicker
                                                        :dim="'sm'"
                                                        v-model="contratto.DATA_PROSSIMA_LIQUIDAZIONE_EDIT"
                                                        placeholder="Data fine liquidazione"
                                                        :class="isDataLiquidazioneValida(contratto) ? 'w-100 mb-1' : 'w-100 mb-1 border-danger'"
                                                        :style="!isDataLiquidazioneValida(contratto) ? 'border: 2px solid #dc3545; border-radius: 4px;' : ''">
                                                    </DatePicker>
                                                    <small class="text-muted">
                                                        Attuale: {{ filters.formatDate(contratto.DATA_PROSSIMA_LIQUIDAZIONE) }}
                                                    </small>
                                                    <small v-if="!isDataLiquidazioneValida(contratto)" class="text-danger d-block">
                                                        <i class="fas fa-exclamation-triangle"></i> Min. 1 mese dopo ultima liquidazione
                                                    </small>
                                                </div>
                                                <span v-else class="badge badge-info">
                                                    <i class="fas fa-info-circle"></i> Primo pagamento
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Card Fatture PDR -->
                                <div v-if="tipoSelezionato === 'PDR'" class="row">
                                    <div class="col-12 mb-3" v-for="fattura in getFattureSelezionateDettaglio()" :key="fattura.ID_FATTURA">
                                        <div class="card shadow-sm border-danger">
                                            <div class="card-body p-3">
                                                <div class="d-flex justify-content-between align-items-start mb-2">
                                                    <span class="badge badge-danger">
                                                        <i class="fas fa-gas-pump"></i> PDR
                                                    </span>
                                                    <span class="badge badge-success font-weight-bold">
                                                        {{ (fattura.MC_FATTURATI * fattura.FATTORE_FAT).toFixed(2) }}€
                                                    </span>
                                                </div>
                                                <h6 class="mb-1">
                                                    <span class="badge badge-secondary">{{ fattura.NUMERO_FATTURA }}</span>
                                                </h6>
                                                <p class="mb-1"><strong>PDR:</strong> {{ fattura.PDR }}</p>
                                                <p class="text-muted mb-0 small">{{ fattura.DENOMINAZIONE }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 mb-3">
                                <div class="form-group">
                                    <label>Descrizione (opzionale)</label>
                                    <textarea v-model="pagamentoSelezionato.DESCRIZIONE"
                                              class="form-control"
                                              rows="3"
                                              placeholder="Inserisci una descrizione per il pagamento (opzionale)"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content-center mb-3">
                            <div class="col-auto">
                                <label class="d-block mb-2">Stato Pagamento:</label>
                                <div class="d-flex align-items-center">
                                    <ISwitch v-model="pagamentoSelezionato.STATO" :size="'sm'"></ISwitch>
                                    <span class="ml-3"
                                        :class="{ 'badge badge-success': pagamentoSelezionato.STATO == 1, 'badge badge-danger': pagamentoSelezionato.STATO == 0 }">
                                        {{ pagamentoSelezionato.STATO == 1 ? 'Saldato' : 'Da Saldare' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button v-if="currentStep === 4"
                            class="btn btn-success btn-lg"
                            @click="salvaPagamento()">
                        <i class="fa fa-check"></i> Salva Pagamento
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- MODALE DESCRIZIONE COMPLETA -->
    <div class="modal fade" id="popUpDescrizioneCompleta" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header" style="background: linear-gradient(135deg, #004B80, #00802B);">
                    <h5 style="color:#fff" class="modal-title">
                        <i class="fas fa-align-left"></i> Descrizione Completa
                    </h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <pre style="white-space: pre-wrap; word-wrap: break-word; font-family: inherit; margin: 0;">{{ descrizioneCompleta }}</pre>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        <i class="fas fa-times"></i> Chiudi
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- MODALE INFO CONTRATTO -->
    <div class="modal fade" id="popUpInfoContratto" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header" style="background: linear-gradient(135deg, #004B80, #00802B);">
                    <h5 style="color:#fff" class="modal-title">
                        <i class="fas fa-info-circle"></i> Dettagli Contratto POD
                    </h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="contrattoInfo" class="container-fluid">
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">POD</label>
                                <p class="h5">{{ contrattoInfo.POD }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Cliente</label>
                                <p class="h5">{{ contrattoInfo.DENOMINAZIONE }}</p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Data Inizio Fornitura</label>
                                <p class="h6">
                                    <i class="fas fa-calendar-check text-success"></i>
                                    {{ filters.formatDate(contrattoInfo.DATA_INIZIO_FORNITURA) }}
                                </p>
                            </div>
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Mesi Trascorsi</label>
                                <p class="h6">
                                    <span class="badge badge-primary" style="font-size: 1em;">
                                        {{ contrattoInfo.MESI_TRASCORSI }} mesi ({{ filters.formatMesiContratto(contrattoInfo.MESI_TRASCORSI) }})
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Gettone Base</label>
                                <p class="h5 text-primary">{{ contrattoInfo.GETTONE_CONTRATTO }}€</p>
                            </div>
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Gettone Maturato</label>
                                <p class="h5 text-success">{{ filters.formatCash(contrattoInfo.GETTONE_MATURATO || contrattoInfo.GETTONE_CONTRATTO) }}€</p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Modalità Pagamento</label>
                                <p>
                                    <span v-if="contrattoInfo.MODALITA_PAGAMENTO == 1" class="badge badge-info" style="font-size: 1em;">
                                        <i class="fas fa-calendar-day"></i> Misto (Anno 1 pieno, poi mensile)
                                    </span>
                                    <span v-else class="badge badge-primary" style="font-size: 1em;">
                                        <i class="fas fa-calendar-alt"></i> Anticipato (Sempre pieno)
                                    </span>
                                </p>
                            </div>
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Tipo Pagamento Corrente</label>
                                <p>
                                    <span v-if="contrattoInfo.FLG_PRIMO_ANNO_PAGATO == 1" class="badge badge-warning" style="font-size: 1em;">
                                        <i class="fas fa-forward"></i> 1° anno già pagato - Mensile
                                    </span>
                                    <span v-else-if="contrattoInfo.MODALITA_PAGAMENTO == 1 && contrattoInfo.MESI_TRASCORSI >= 12" class="badge badge-info" style="font-size: 1em;">
                                        <i class="fas fa-calendar-day"></i> Mensile (10€/mese)
                                    </span>
                                    <span v-else class="badge badge-success" style="font-size: 1em;">
                                        <i class="fas fa-calendar-alt"></i> Annuale (120€)
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Ultima Liquidazione</label>
                                <p class="h6">
                                    <span v-if="contrattoInfo.DATA_ULTIMA_LIQUIDAZIONE" class="badge badge-warning text-dark" style="font-size: 1em;">
                                        {{ filters.formatDate(contrattoInfo.DATA_ULTIMA_LIQUIDAZIONE) }}
                                    </span>
                                    <span v-else class="badge badge-danger" style="font-size: 1em;">Mai liquidato</span>
                                </p>
                            </div>
                            <div class="col-md-6">
                                <label class="font-weight-bold text-muted small">Prossima Liquidazione Prevista</label>
                                <p class="h6">
                                    <span v-if="contrattoInfo.DATA_PROSSIMA_LIQUIDAZIONE" class="badge badge-info" style="font-size: 1em;">
                                        {{ filters.formatDate(contrattoInfo.DATA_PROSSIMA_LIQUIDAZIONE) }}
                                    </span>
                                    <span v-else class="text-muted">Non disponibile</span>
                                </p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-info">
                                    <i class="fas fa-info-circle"></i>
                                    <strong>Spiegazione:</strong>
                                    <ul class="mb-0 mt-2">
                                        <li v-if="contrattoInfo.FLG_PRIMO_ANNO_PAGATO == 1">
                                            <strong>Primo anno già pagato</strong>: il gettone del primo anno è stato già erogato esternamente. Il sistema calcola solo i ratei mensili.
                                        </li>
                                        <li v-else-if="contrattoInfo.MODALITA_PAGAMENTO == 0">
                                            Modalità <strong>Anticipato</strong>: il gettone viene sempre pagato per intero ogni 13 mesi.
                                        </li>
                                        <li v-else-if="contrattoInfo.MESI_TRASCORSI < 12">
                                            Modalità <strong>Mista</strong> - <strong>Primo anno</strong>: il gettone viene pagato per intero. Dal 13° mese passerà a pagamento mensile.
                                        </li>
                                        <li v-else>
                                            Modalità <strong>Mista</strong> - <strong>Dal secondo anno</strong>: il gettone viene pagato mensilmente. Sono trascorsi {{ filters.formatMesiContratto(contrattoInfo.MESI_TRASCORSI) }} dalla data di inizio della fornitura.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        <i class="fas fa-times"></i> Chiudi
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import Select2 from '@/components/utils/Select2.vue'
import DatePicker from '@/components/utils/DatePicker.vue'
import ISwitch from '../components/utils/ISwitch.vue';



export default {
    name: "Pagamenti",
    components: {
        Pagine,
        Select2,
        DatePicker,
        ISwitch
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                ID_PAGAMENTO: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
                DATA_PAGAMENTO: { TYPE: 'DATE_RANGE', VALUE_FROM: '', VALUE_TO: '' },
                IMPORTO: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
                STATO: { TYPE: 'COMBO', VALUE: '' },
            },
            searchPod: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
                POD: { TYPE: 'TEXT', VALUE: '' },
            },
            searchFatturePdr: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
                NUMERO_FATTURA: { TYPE: 'TEXT', VALUE: '' },
                PDR: { TYPE: 'TEXT', VALUE: '' },
            },
            arrayPagamenti: new Array(),
            pagamentoSelezionato: {},
            showFilters: false,
            contrattiDaLiquidare: [],
            fatturePdrDaLiquidare: [],
            contrattiSelezionati: [],
            fattureSelezionate: [],
            currentStep: 1,
            tipoSelezionato: null,
            contrattoInfo: null,
            descrizioneCompleta: '',
        }
    },
    methods: {
        mostraInfoContratto: function(contratto) {
            this.contrattoInfo = contratto;
            utils.openModal('popUpInfoContratto');
        },
        mostraDescrizioneCompleta: function(descrizione) {
            if (descrizione && descrizione.length > 30) {
                this.descrizioneCompleta = descrizione;
                utils.openModal('popUpDescrizioneCompleta');
            }
        },
        updateStato: function (pagamento) {
            global.utils.put('/dcp/pagamento/stato', { ID_PAGAMENTO: pagamento.ID_PAGAMENTO, STATO: pagamento.STATO }, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio);
                    this.getPagamenti();
                }
            });
        },
        getPagamenti: function () {
            global.utils.get('/dcp/pagamenti', {}, (response) => {
                this.arrayPagamenti = response.data;
            });
        },
        nuovoPagamento: function () {
            this.pagamentoSelezionato = { ID_PAGAMENTO: 0, STATO: 1 }
            this.contrattiSelezionati = [];
            this.fattureSelezionate = [];
            this.contrattiDaLiquidare = [];
            this.fatturePdrDaLiquidare = [];
            this.currentStep = 1;
            this.tipoSelezionato = null;
            utils.openModal('popUpPagamento');
        },
        goToStep2: function () {
            if (!this.pagamentoSelezionato.FK_ID_AGENTE) {
                utils.alert.warning("Selezionare un Agente");
                return;
            }
            this.currentStep = 2;
        },
        selezionaTipo: function (tipo) {
            this.tipoSelezionato = tipo;
            if (tipo === 'GENERICO') {
                this.goToStep4();
            } else {
                this.currentStep = 3;
            }
        },
        goToStep4: function () {
            // Genera descrizione automatica in base ai contratti/fatture selezionati
            let descrizione = '';
            const dataOggi = new Date().toLocaleDateString('it-IT');

            if (this.tipoSelezionato === 'POD') {
                const contratti = this.getContrattiSelezionatiDettaglio();
                const pods = contratti.map(c => c.POD).join(', ');
                const totale = this.calcolaTotaleGettoni();
                descrizione = `Liquidazione POD del ${dataOggi}\n`;
                descrizione += `Contratti: ${contratti.length}\n`;
                descrizione += `POD: ${pods}\n`;
                descrizione += `Totale: ${totale}€`;
            } else if (this.tipoSelezionato === 'PDR') {
                const fatture = this.getFattureSelezionateDettaglio();
                const numFatture = fatture.map(f => f.NUMERO_FATTURA).join(', ');
                const pdrs = [...new Set(fatture.map(f => f.PDR))].join(', ');
                const totale = this.calcolaTotaleGettoni();
                descrizione = `Liquidazione Fatture PDR del ${dataOggi}\n`;
                descrizione += `Fatture: ${numFatture}\n`;
                descrizione += `PDR: ${pdrs}\n`;
                descrizione += `Totale: ${totale}€`;
            } else if (this.tipoSelezionato === 'GENERICO') {
                descrizione = `Pagamento generico del ${dataOggi}`;
                this.pagamentoSelezionato.IMPORTO = this.pagamentoSelezionato.IMPORTO || 0;
            }

            this.pagamentoSelezionato.DESCRIZIONE = descrizione;
            this.currentStep = 4;
        },
        loadContrattiDaLiquidare: function () {
            if (!this.pagamentoSelezionato.FK_ID_AGENTE) {
                this.contrattiDaLiquidare = [];
                return;
            }

            global.utils.get('/dcp/contratti/da-liquidare', { FK_ID_AGENTE: this.pagamentoSelezionato.FK_ID_AGENTE }, (response) => {
                if (response.esito == 0) {
                    this.contrattiDaLiquidare = response.data;
                } else {
                    this.contrattiDaLiquidare = [];
                }
            });
        },
        loadFatturePdrDaLiquidare: function () {
            if (!this.pagamentoSelezionato.FK_ID_AGENTE) {
                this.fatturePdrDaLiquidare = [];
                return;
            }

            // Carica tutte le fatture e filtra lato frontend
            global.utils.get('/dcp/fatture', { FK_ID_AGENTE: this.pagamentoSelezionato.FK_ID_AGENTE }, (response) => {
                if (response.esito == 0) {
                    // Filtra solo fatture PDR (FK_ID_TIPO = 2), elaborate (ELABORATO = 1), pagate dal cliente (PAGATA = 1) e non ancora pagate all'agente (PAGATA_AG != 1)
                    this.fatturePdrDaLiquidare = response.data.filter(f =>
                        f.FK_ID_TIPO == 2 && f.ELABORATO == 1 && f.PAGATA == 1 && f.PAGATA_AG != 1
                    );
                } else {
                    this.fatturePdrDaLiquidare = [];
                }
            });
        },
        calcolaTotaleGettoni: function () {
            let totale = 0;

            // Se è POD, calcola in base ai contratti con GETTONE_MATURATO (o GETTONE_CONTRATTO come fallback)
            if (this.tipoSelezionato === 'POD' && this.contrattiDaLiquidare && this.contrattiDaLiquidare.length > 0) {
                totale = this.contrattiDaLiquidare
                    .filter(c => this.contrattiSelezionati.includes(c.ID_CONTRATTO))
                    .reduce((sum, c) => sum + parseFloat(c.GETTONE_MATURATO || c.GETTONE_CONTRATTO || 0), 0);
            }

            // Se è PDR, calcola in base alle fatture con MC_FATTURATI × FATTORE_FAT
            if (this.tipoSelezionato === 'PDR') {
                const fatture = Array.isArray(this.fatturePdrDaLiquidare) ? this.fatturePdrDaLiquidare : [];
                if (fatture.length > 0) {
                    totale = fatture
                        .filter(f => this.fattureSelezionate.includes(f.ID_FATTURA))
                        .reduce((sum, f) => sum + (parseFloat(f.MC_FATTURATI || 0) * parseFloat(f.FATTORE_FAT || 0)), 0);
                }
            }

            return totale.toFixed(2);
        },
        deletePagamento: function (agente) {
            utils.alert.confirm("Sei sicuro di voler eliminare il pagamento selezionato?", () => {
                global.utils.delete('/dcp/pagamento', { ID_PAGAMENTO: agente.ID_PAGAMENTO }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getPagamenti();
                    }
                });
            }, this.$root);
        },
        eliminaPagamento: function (pagamento) {
            this.deletePagamento(pagamento);
        },
        toggleContratto: function(idContratto) {
            const index = this.contrattiSelezionati.indexOf(idContratto);
            if (index > -1) {
                this.contrattiSelezionati.splice(index, 1);
            } else {
                this.contrattiSelezionati.push(idContratto);
            }
        },
        toggleAllPod: function(event) {
            if (event.target.checked) {
                this.contrattiSelezionati = this.podDaLiquidare.arr.map(c => c.ID_CONTRATTO);
            } else {
                this.contrattiSelezionati = [];
            }
        },
        toggleFattura: function(idFattura) {
            const index = this.fattureSelezionate.indexOf(idFattura);
            if (index > -1) {
                this.fattureSelezionate.splice(index, 1);
            } else {
                this.fattureSelezionate.push(idFattura);
            }
        },
        toggleAllFatturePdr: function(event) {
            if (event.target.checked) {
                this.fattureSelezionate = this.fatturePdrDaLiquidarePaginato.arr.map(f => f.ID_FATTURA);
            } else {
                this.fattureSelezionate = [];
            }
        },
        getContrattiPODSelezionati: function() {
            return this.contrattiDaLiquidare.filter(c =>
                this.contrattiSelezionati.includes(c.ID_CONTRATTO) && c.POD && c.POD.length > 1
            );
        },
        getContrattiPDRSelezionati: function() {
            return this.contrattiDaLiquidare.filter(c =>
                this.contrattiSelezionati.includes(c.ID_CONTRATTO) && c.PDR && c.PDR.length > 1
            );
        },
        getContrattiSelezionatiDettaglio: function() {
            return this.contrattiDaLiquidare.filter(c =>
                this.contrattiSelezionati.includes(c.ID_CONTRATTO)
            );
        },
        getFattureSelezionateDettaglio: function() {
            const fatture = Array.isArray(this.fatturePdrDaLiquidare) ? this.fatturePdrDaLiquidare : [];
            return fatture.filter(f =>
                this.fattureSelezionate.includes(f.ID_FATTURA)
            );
        },
        isDataLiquidazioneValida: function(contratto) {
            // Verifica se la data prossima liquidazione è valida (almeno 1 mese dopo l'ultima)
            if (!contratto.DATA_PROSSIMA_LIQUIDAZIONE_EDIT || !contratto.DATA_ULTIMA_LIQUIDAZIONE) {
                return true; // Se non c'è data modificata o ultima liquidazione, è valido
            }

            const dataUltimaLiquidazione = new Date(contratto.DATA_ULTIMA_LIQUIDAZIONE);
            const dataProssimaLiquidazione = new Date(contratto.DATA_PROSSIMA_LIQUIDAZIONE_EDIT);

            // Calcola la data minima (1 mese dopo l'ultima liquidazione)
            const dataMinima = new Date(dataUltimaLiquidazione);
            dataMinima.setMonth(dataMinima.getMonth() + 1);

            return dataProssimaLiquidazione >= dataMinima;
        },
        validaDateLiquidazione: function() {
            // Valida che la data prossima liquidazione sia almeno 1 mese dopo l'ultima liquidazione
            if (this.tipoSelezionato !== 'POD') return { valido: true };

            const contrattiSelezionati = this.getContrattiSelezionatiDettaglio();

            for (const contratto of contrattiSelezionati) {
                // Se il contratto ha una data modificata
                if (contratto.DATA_PROSSIMA_LIQUIDAZIONE_EDIT && contratto.DATA_ULTIMA_LIQUIDAZIONE) {
                    const dataUltimaLiquidazione = new Date(contratto.DATA_ULTIMA_LIQUIDAZIONE);
                    const dataProssimaLiquidazione = new Date(contratto.DATA_PROSSIMA_LIQUIDAZIONE_EDIT);

                    // Calcola la data minima (1 mese dopo l'ultima liquidazione)
                    const dataMinima = new Date(dataUltimaLiquidazione);
                    dataMinima.setMonth(dataMinima.getMonth() + 1);

                    if (dataProssimaLiquidazione < dataMinima) {
                        return {
                            valido: false,
                            messaggio: `POD ${contratto.POD}: La data prossima liquidazione deve essere almeno 1 mese dopo l'ultima liquidazione (${this.filters.formatDate(contratto.DATA_ULTIMA_LIQUIDAZIONE)})`
                        };
                    }
                }
            }

            return { valido: true };
        },
        salvaPagamento: function () {
            // Validazioni
            if (!this.pagamentoSelezionato.FK_ID_AGENTE) {
                utils.alert.warning("Selezionare un Agente");
                return;
            }

            if (this.tipoSelezionato === 'GENERICO') {
                // Pagamento generico: richiede solo importo > 0
                const importo = parseFloat(this.pagamentoSelezionato.IMPORTO);
                if (!importo || importo <= 0) {
                    utils.alert.warning("Inserire un importo valido per il pagamento generico");
                    return;
                }
                this.pagamentoSelezionato.IMPORTO = importo;
                this.pagamentoSelezionato.CONTRATTI_SELEZIONATI = [];
                this.pagamentoSelezionato.FATTURE_SELEZIONATE = [];
            } else {
                // Verifica che ci siano contratti POD o fatture PDR selezionati
                if (this.tipoSelezionato === 'POD' && this.contrattiSelezionati.length === 0) {
                    utils.alert.warning("Selezionare almeno un contratto POD da liquidare");
                    return;
                }

                if (this.tipoSelezionato === 'PDR' && this.fattureSelezionate.length === 0) {
                    utils.alert.warning("Selezionare almeno una fattura PDR da liquidare");
                    return;
                }

                // Valida le date di liquidazione per i POD
                const validazioneDate = this.validaDateLiquidazione();
                if (!validazioneDate.valido) {
                    utils.alert.warning(validazioneDate.messaggio);
                    return;
                }

                // Calcola automaticamente l'importo in base ai contratti/fatture selezionati
                this.pagamentoSelezionato.IMPORTO = parseFloat(this.calcolaTotaleGettoni());

                // Aggiungi i contratti o le fatture selezionate al payload
                if (this.tipoSelezionato === 'POD') {
                    this.pagamentoSelezionato.CONTRATTI_SELEZIONATI = this.contrattiSelezionati;
                    this.pagamentoSelezionato.FATTURE_SELEZIONATE = [];
                } else if (this.tipoSelezionato === 'PDR') {
                    this.pagamentoSelezionato.CONTRATTI_SELEZIONATI = [];
                    this.pagamentoSelezionato.FATTURE_SELEZIONATE = this.fattureSelezionate;
                }
            }

            this.pagamentoSelezionato.TIPO_PAGAMENTO = this.tipoSelezionato;

            const endpoint = this.tipoSelezionato === 'GENERICO' ? '/dcp/pagamento_generico' : '/dcp/pagamento';
            global.utils.post(endpoint, this.pagamentoSelezionato, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio);
                    this.getPagamenti();
                    utils.closeModal('popUpPagamento');
                }
            });
        }

    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayPagamenti, this.search);
            return arr;
        },
        podDaLiquidare() {
            var arr = utils.inGrid(this.contrattiDaLiquidare.filter(c => c.POD && c.POD.length > 1),this.searchPod);
            return arr;
        },
        fatturePdrDaLiquidarePaginato() {
            // Assicura che fatturePdrDaLiquidare sia un array
            const fatture = Array.isArray(this.fatturePdrDaLiquidare) ? this.fatturePdrDaLiquidare : [];
            var arr = utils.inGrid(fatture, this.searchFatturePdr);
            return arr;
        },
    },
    watch: {
        'pagamentoSelezionato.FK_ID_AGENTE': function(newVal) {
            if (newVal && this.currentStep === 1) {
                this.loadContrattiDaLiquidare();
                this.loadFatturePdrDaLiquidare();
            } else if (!newVal) {
                this.contrattiDaLiquidare = [];
                this.fatturePdrDaLiquidare = [];
                this.contrattiSelezionati = [];
                this.fattureSelezionate = [];
            }
        }
    },
    created: function () {
        this.getPagamenti();
    },
}
</script>
<style scoped>
.offcanvas-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .15);
    opacity: 0;
    visibility: hidden;
    transition: opacity .2s ease, visibility .2s ease;
    z-index: 1040;
}

.offcanvas-backdrop.show {
    opacity: 1;
    visibility: visible;
}

.offcanvas-panel {
    position: fixed;
    top: 0;
    right: -100%;
    height: 100vh;
    width: 88%;
    max-width: 420px;
    background: #fff;
    box-shadow: -6px 0 24px rgba(0, 0, 0, .15);
    z-index: 1050;
    display: flex;
    flex-direction: column;
    transition: right .25s ease;
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
}

.offcanvas-panel.open {
    right: 0;
}

.offcanvas-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .75rem 1rem;
    border-bottom: 1px solid #eee;
}

.offcanvas-body {
    flex: 1;
    padding: 1rem;
    overflow-y: auto;
}

/* Quando la larghezza della finestra è maggiore o uguale a 1229px */
@media (min-width: 1230px) {
    .isprint-grid-container {
        margin-top: 20px;
        width: auto;
        table-layout: auto;
    }
}

/* Quando la larghezza della finestra è inferiore a 1396px */
@media (max-width: 1229px) {
    .isprint-grid-container {
        margin-top: 100px;
    }
}

.mobile-page-title {
    padding: 15px;
    background: linear-gradient(135deg, #004B80, #00802B);
    color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
}

.mobile-page-title h4 {
    margin: 0;
    color: white;
}

.mobile-page-title i {
    margin-right: 8px;
}

/* Nascondi il portlet head in mobile visto che è vuoto */
@media (max-width: 767px) {
    .kt-portlet__head {
        height: 0 !important;
        overflow: hidden;
    }
}

/* Card interattive per selezione tipo contratto */
.card.shadow-sm {
    transition: all 0.3s ease;
}

.card.shadow-sm:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

/* Bordo evidenziato per card selezionata */
.border-warning {
    border-color: #ffc107 !important;
    border-width: 3px !important;
}

.border-danger {
    border-color: #dc3545 !important;
    border-width: 3px !important;
}

/* Stile per le checkbox più grandi */
input[type="checkbox"] {
    cursor: pointer;
}

/* List group items hover effect */
.list-group-item:hover {
    background-color: #f8f9fa;
}

/* Evidenzia righe selezionate nella tabella */
.isprint-grid tbody tr.table-active {
    background-color: #d4edda !important;
    border-left: 4px solid #28a745;
}

.isprint-grid tbody tr:hover {
    background-color: #f8f9fa;
}

.isprint-grid tbody tr.table-active:hover {
    background-color: #c3e6cb !important;
}

/* Tabella contratti nel modale con altezza fissa e scroll nel tbody */
.table-contratti-modal {
    display: block;
    width: 100%;
}

.table-contratti-modal thead {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.table-contratti-modal .tbody-scrollable {
    display: block;
    max-height: 300px;
    overflow-y: auto;
    width: 100%;
}

.table-contratti-modal .tbody-scrollable tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.table-contratti-modal .tbody-scrollable td {
    font-size: 14px !important;
}
</style>
